import { render } from "./index.vue?vue&type=template&id=507b42f0&scoped=true&ts=true"
import script from "./index.vue?vue&type=script&lang=ts"
export * from "./index.vue?vue&type=script&lang=ts"

import "./index.vue?vue&type=style&index=0&id=507b42f0&lang=less&scoped=true"

import exportComponent from "/root/.jenkins/workspace/production-Q-saas-plat-manage-vue/node_modules/_vue-loader@16.8.3@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-507b42f0"]])

export default __exports__